import { Button, Tooltip } from 'antd'
import React, { useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { TableComp } from 'sz-react-utils-lite'
import { DefaultTablePagination, displayDate, displayTime } from '../../../components/_utils/appUtils'
import UpdateWithdrawalIssueStatus from './updateIssueStatusDrawer'
import { getWithdrawalIssuesFxn } from '../actions/commissionAction'

const WithdrawalIssueList = () => {
  let [total, setTotal] = useState([])
  let [commissionState, setCommissionState] = useState({
    withdrawalIssueId: '',
    visible: false
  })

  const tableRef = useRef()
  const dispatch = useDispatch()

  const apiRequest = params => {
    return new Promise(async resolve => {
      let resp = await dispatch(getWithdrawalIssuesFxn({ ...params }))
      setTotal(resp.total)
      resolve(resp)
    })
  }


  const events = {
    showDrawer: (withdrawalIssueId) => {
      setCommissionState({
        withdrawalIssueId,
        visible: true
      })
    },
    hideDrawer: () => {
      setCommissionState({
        withdrawalIssueId: '',
        status: '',
        visible: false
      })
      tableRef.current.reload()
    }
  }

  const columns = [
    {
      title: 'Issue/Request',
      key: 'issue',
      dataIndex: 'issue'
    },
    {
      title: 'Details',
      key: 'note',
      dataIndex: 'note'
    },
    {
      title: 'Added On',
      key: 'createdAt',
      dataIndex: 'createdAt',
      render: val => {
        return <div>{displayDate(val)}</div>
      }
    },
    {
      title: 'Added By',
      key: 'addedBy',
      dataIndex: 'addedBy',
      render: val => {
        return val && <div>{val.companyName} ({val.name})</div>
      }
    },
    {
      title: 'Status',
      key: 'status',
      dataIndex: 'status',
      render: (val) => {
        return (
          <div>
            {val == 'Pending' ?
              <label className={'label label-xs label-warning'}>Pending</label> : null}
            {val == 'Rejected' ?
              <label className={'label label-xs label-danger'}>Rejected</label> : null}
            {val == 'Approved' ?
              <label className={'label label-xs label-success-green'}>Approved</label> : null}
          </div>
        )
      }
    },
    {
      title: 'Updated By',
      key: 'issue',
      dataIndex: 'issue',
      render: (item, record) => {
        return (
          <div className='btn_group' style={{ width: 200 }}>
            {record.approvedBy && (
              <>
                <div>
                  Approved By - {record.approvedBy.name}
                  <br />
                  Date - {record.approvedBy.date && displayDate(record.approvedBy.date)}
                  <br />
                  Time - {record.approvedBy.date && displayTime(record.approvedBy.date)}
                </div>
              </>
            )}
            {record.rejectedBy && (
              <>
                <div>
                  Rejected By - {record.rejectedBy.name}
                  <br />
                  Date - {record.rejectedBy.date && displayDate(record.rejectedBy.date)}
                  <br />
                  Time - {record.rejectedBy.date && displayTime(record.rejectedBy.date)}
                </div>
              </>
            )}
          </div>
        )
      }
    },
    {
      title: 'Action',
      dataIndex: 'status',
      key: 'status',
      width: 220,
      render: (item, record) => {
        return (
          <>
            <div className={'btn_group'} style={{ width: 200 }}>
              {item == 'Pending' ? (
                <>
                  <Tooltip title={'Update Status'}>
                    <a className={'bs_btn bs-xs bs-default'}
                       onClick={() => {
                         events.showDrawer(record._id)
                       }}>
                      Update Status
                    </a>
                  </Tooltip>
                </>
              ) : null}
            </div>
          </>
        )
      }
    }
  ]

  return (
    <div>
      <div className='row mt-4'>
        <div className='col-lg-12'>
          <div className='card'>
            <div className='table-head d-flex align-items-center all-student-search'>
              <Button onClick={() => events.goBack()}
                      className={'roundGoBackBtn'} icon={'arrow-left'}>
                Back
              </Button>
              <h5>All Withdrawal Issue/Requests (<small>Total {total}</small>)</h5>
              <div className='search-box-table round'>
              </div>
              <div className='sort-box-table mark-btn'>
              </div>
            </div>
            <div className='card-body table-responsive'>
              <TableComp
                columns={columns}
                apiRequest={apiRequest}
                pagination={DefaultTablePagination()}
                ref={tableRef}
              />
            </div>
          </div>

        </div>
      </div>

      {commissionState.visible ? (
        <UpdateWithdrawalIssueStatus
          {...commissionState}
          onSubmit={events.hideDrawer}
          onClose={events.hideDrawer}
        />
      ) : null}
    </div>
  )
}

export default WithdrawalIssueList
